"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreviousValue = void 0;
var react_1 = require("react");
/**
 * A helper hook which retains the `value` param from a component's previous render.
 *
 * May be useful if you need to e.g. access the value of a component's previous state.
 */
var usePreviousValue = function (value) {
    var ref = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
};
exports.usePreviousValue = usePreviousValue;
